import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useGetOtherReportBranchTableDataQuery } from "../../../../store/queries/Reports";
import { useFormik } from "formik";
import { updateConfig } from "../../../../store/slices/Reports/reportsSlice";
import { useState } from "react";
import { subDays } from "date-fns";
import { downloadShopReport } from "../../api";
import { toast } from "react-toastify";
import moment from "moment";
import { createStaticRanges } from "react-date-range";
import { startOfWeek, endOfWeek, subWeeks } from "date-fns";

const useShopReport = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];

  // eslint-disable-next-line no-unused-vars
  const [date, setDate] = useState({
    startDate: subDays(new Date(), 14),
    endDate: new Date(),
    key: "selection",
  });
  const [loading, setLoading] = useState(false);
  const startDate = new Date(date.startDate).toISOString().split("T")[0];
  const endDate = new Date(date.endDate).toISOString().split("T")[0];
  const initialFormattedDate = [startDate, endDate];
  const [formattedDate, setFormattedDate] = useState(initialFormattedDate);

  const dispatch = useDispatch();
  const reportState = useSelector((state) => state.reports);

  const formik = useFormik({
    initialValues: {
      shop: "",
      branch: "",
      supplier: "",
      order_type: "",
    },
  });

  const { data: branchReportData = {}, isFetching } =
    useGetOtherReportBranchTableDataQuery(
      {
        type: 1,
        date: formattedDate,
        per_page: reportState?.otherReport?.currentPageSize,
        page: reportState?.otherReport?.currentPage,
        sort_by: reportState?.otherReport?.sortBy,
        sort_order: reportState?.otherReport?.sortOrder,
        search: reportState?.otherReport?.search,
        // branch_id: formik?.values?.branch?._id,
        branch_id: reportState?.otherReport?.currentBranchFilter,
        order_type: formik?.values?.order_type?.id,
        shop_id: formik?.values?.shop?._id,
        supplier_id: formik?.values?.supplier?._id,
        source_id: reportState?.otherReport?.currentSourceFilter,
        work_status: reportState?.otherReport?.currentWorkStatusFilter,
      },
      {
        skip: !(
          // formik?.values?.branch &&
          (
            formik?.values?.order_type &&
            (formik?.values?.shop || formik?.values?.supplier)
          )
        ),
      },
    );
  const cardData = [
    {
      label: "Total GLI",
      value: branchReportData?.data?.total_gli ?? "--",
    },
    {
      label: "Total certificates",
      value: branchReportData?.data?.total_item_details_count ?? "--",
    },
    {
      label: "Completed",
      value: branchReportData?.data?.total_completed_count ?? "--",
    },
    {
      label: "Rejected",
      value: branchReportData?.data?.total_rejected_count ?? "--",
    },
    {
      label: "Marked",
      value: branchReportData?.data?.total_marked_count ?? "--",
    },
    {
      label: "Certification",
      value: branchReportData?.data?.total_certification ?? "--",
    },
    {
      label: "Quality Check",
      value: branchReportData?.data?.total_qc ?? "--",
    },
    {
      label: "CVD",
      value: branchReportData?.data?.total_cvd ?? "--",
    },
    {
      label: "Engraving",
      value: branchReportData?.data?.total_engraving ?? "--",
    },
    {
      label: "Metal QC",
      value: branchReportData?.data?.total_metal_qc ?? "--",
    },
  ];

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.otherReport.currentPageSize = page_size;
        state.otherReport.currentPage = 1;
      }),
    );
  };
  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.otherReport.currentPage = page;
      }),
    );
  };

  const handleBranchFilter = (ids) => {
    dispatch(
      updateConfig((state) => {
        state.otherReport.currentPage = 1;
        state.otherReport.currentBranchFilter = ids;
      }),
    );
  };

  const handleSourceFilter = (ids) => {
    dispatch(
      updateConfig((state) => {
        state.otherReport.currentPage = 1;
        state.otherReport.currentSourceFilter = ids;
      }),
    );
  };

  const handleWorkStatusFilter = (ids) => {
    dispatch(
      updateConfig((state) => {
        state.otherReport.currentPage = 1;
        state.otherReport.currentWorkStatusFilter = ids;
      }),
    );
  };

  const handleSort = (label) => {
    if (reportState.otherReport.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.otherReport.currentPage = 1;
          state.otherReport.sortOrder =
            reportState.otherReport.sortOrder === "asc" ? "desc" : "asc";
        }),
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.otherReport.currentPage = 1;
          state.otherReport.sortBy = label;
          state.otherReport.sortOrder = "asc";
        }),
      );
    }
  };

  const handleDateChange = (selectedDate) => {
    const daysDiff = Math.ceil(
      (selectedDate.endDate - selectedDate.startDate) / (1000 * 60 * 60 * 24),
    );

    if (daysDiff > 59) {
      selectedDate.endDate = new Date(
        selectedDate.startDate.getTime() + 59 * 24 * 60 * 60 * 1000,
      );

      toast.warn(
        "Maximum allowed range is 60 days. The selection has been adjusted automatically.",
        {
          style: {
            background: "orange",
            color: "black",
          },
        },
      );
      setTimeout(() => {
        document.querySelector('[title="Date range dropdown"]')?.click();
      }, 100);
    }

    // Your existing code remains the same
    const startDateUTC = new Date(selectedDate.startDate);
    const endDateUTC = new Date(selectedDate.endDate);
    const timeZoneOffset = 5.5 * 60 * 60 * 1000;
    const startDateIST = new Date(startDateUTC.getTime() + timeZoneOffset);
    const endDateIST = new Date(endDateUTC.getTime() + timeZoneOffset);

    const formatDate = (date) => {
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const startDateFormatted = formatDate(startDateIST);
    const endDateFormatted = formatDate(endDateIST);
    const dateArray = [startDateFormatted, endDateFormatted];
    setFormattedDate(dateArray);
  };

  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.otherReport.search = e.target.value;
        state.otherReport.currentPage = 1;
      }),
    );
  };

  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data[field]}</p>,
      service: (feild, data) => (
        <ul>
          {data[feild]?.map(({ name }, index) => (
            <li key={index}>{name}</li>
          ))}
        </ul>
      ),
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };

  const handleDownloadClick = () => {
    setLoading(true);
    let data = {
      type: 1,
      date: formattedDate,
      per_page: reportState?.otherReport?.currentPageSize,
      page: reportState?.otherReport?.currentPage,
      sort_by: reportState?.otherReport?.sortBy,
      sort_order: reportState?.otherReport?.sortOrder,
      search: reportState?.otherReport?.search,
      // branch_id: formik?.values?.branch?._id,
      branch_id: reportState?.otherReport?.currentBranchFilter,
      order_type: formik?.values?.order_type?.id,
      shop_id: formik?.values?.shop?._id,
      supplier_id: formik?.values?.supplier?._id,
      source_id: reportState?.otherReport?.currentSourceFilter,
      work_status: reportState?.otherReport?.currentWorkStatusFilter,
    };
    downloadShopReport(data).then((response) => {
      if (response?.status === 200) {
        setLoading(false);
        // toast.success(
        //   response?.data?.message ??
        //     "Export queued. You'll see it in Notifications when ready.",
        // );
        // Direct file download disabled — the export is now queued and
        // delivered through Notifications. Kept for future reference.
        let dataType = response?.data?.type;
        let binaryData = [];
        binaryData.push(response?.data);
        let downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );
        downloadLink.setAttribute(
          "download",
          `Supplier Shop Report_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.xlsx`,
        );
        document.body.appendChild(downloadLink);
        downloadLink.click();
      } else if (response?.status === 403) {
        setLoading(false);
        toast.warning("Invalid Data");
      } else {
        setLoading(false);
        toast.error("Something went wrong");
      }
    });
  };
  const customStaticRanges = createStaticRanges([
    {
      label: "Today",
      range: () => ({
        startDate: new Date(),
        endDate: new Date(),
      }),
    },
    {
      label: "Last 7 Days",
      range: () => {
        const now = new Date();
        const past = new Date();
        past.setDate(now.getDate() - 6); // include today
        return {
          startDate: past,
          endDate: now,
        };
      },
    },
    {
      label: "This Week",
      range: () => {
        const now = new Date();
        return {
          startDate: startOfWeek(now, { weekStartsOn: 1 }), // Monday as start
          endDate: endOfWeek(now, { weekStartsOn: 1 }),
        };
      },
    },
    {
      label: "Last Week",
      range: () => {
        const now = new Date();
        const lastWeekStart = startOfWeek(subWeeks(now, 1), {
          weekStartsOn: 1,
        });
        const lastWeekEnd = endOfWeek(subWeeks(now, 1), { weekStartsOn: 1 });
        return {
          startDate: lastWeekStart,
          endDate: lastWeekEnd,
        };
      },
    },
  ]);

  return {
    date,
    formik,
    cardData,
    isFetching,
    reportState,
    paginationOptions,
    branchReportData,
    customStaticRanges,
    loading,
    getRow,
    handleSort,
    handleSearch,
    handlePageSize,
    handleDateChange,
    handlePagination,
    handleBranchFilter,
    handleSourceFilter,
    handleWorkStatusFilter,
    handleDownloadClick,
  };
};

export default useShopReport;
